import { render, staticRenderFns } from "./AccountWhite.vue?vue&type=template&id=bd7d3be2&scoped=true&"
var script = {}
import style0 from "./AccountWhite.vue?vue&type=style&index=0&id=bd7d3be2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7d3be2",
  null
  
)

export default component.exports